import { render, staticRenderFns } from "./ToggleForm.vue?vue&type=template&id=50b1c784&scoped=true"
import script from "./ToggleForm.vue?vue&type=script&lang=js"
export * from "./ToggleForm.vue?vue&type=script&lang=js"
import style0 from "./ToggleForm.vue?vue&type=style&index=0&id=50b1c784&prod&scoped=true&lang=scss"
import style1 from "./ToggleForm.vue?vue&type=style&index=1&id=50b1c784&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b1c784",
  null
  
)

export default component.exports